// extracted by mini-css-extract-plugin
export default {"inner":"L_inner__0Mbus","outer":"L_outer__+gLaM","inner1":"L_inner1__iPk4V","inner2":"L_inner2__dSLzE","wrapper":"L_wrapper__KXwG7"};